import { useState, useCallback } from "react";

const useStateManager = (initialState) => {
  const [state, setState] = useState(initialState);

  const deepClone = (obj) => {
    if (obj === null || typeof obj !== "object") return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (obj instanceof Array) return obj.map(item => deepClone(item));
    if (typeof obj === "object") {
      const clonedObj = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          clonedObj[key] = deepClone(obj[key]);
        }
      }
      return clonedObj;
    }
    return obj;
  };

  const updateState = useCallback((newStateValues) => {
    setState((prevState) => ({
      ...prevState,
      ...(typeof newStateValues === "function" 
        ? newStateValues(prevState) 
        : newStateValues),
    }));
  }, []);

  const updateNestedKey = useCallback((keyPath, newValue) => {
    setState((prevState) => {
      const newState = deepClone(prevState);
      let current = newState;
      
      for (let i = 0; i < keyPath.length - 1; i++) {
        const key = keyPath[i];
        if (!current[key]) {
          current[key] = {};
        } else {
          current[key] = deepClone(current[key]);
        }
        current = current[key];
      }
      
      const finalKey = keyPath[keyPath.length - 1];
      current[finalKey] = typeof newValue === "function" 
        ? newValue(current[finalKey]) 
        : newValue;
      
      return newState;
    });
  }, []);

  const resetState = useCallback(() => {
    setState(initialState);
  }, [initialState]);

  return [state, updateState, updateNestedKey, resetState];
};

export default useStateManager;